import {
  CheckIcon,
  FormControlLabel,
  GKButton,
  GKModal,
  GKRadio,
  GKTextField,
  Grid2,
  RadioGroup,
  SearchIcon,
} from "components";
import { useEffect, useState } from "react";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  portfolioList?: any[];
  onFamilySelect: (id: number) => void;
  selectedFamilyId?: number;
}

const SelectFamilyModal = (props: Props) => {
  const { open, setOpen, portfolioList, onFamilySelect, selectedFamilyId } =
    props;

  const [selectedFamily, setSelectedFamily] = useState<string | null>(null);

  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!open) return;

    if (selectedFamilyId) {
      setSelectedFamily(String(selectedFamilyId));
    } else {
      setSelectedFamily(null);
      setSearch("");
    }
  }, [selectedFamilyId, open]);

  const familyList = portfolioList?.filter((item) => item.type === "family");

  const filteredFamily = familyList?.filter((f) =>
    f.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <GKModal
      width={"318px"}
      open={open}
      setOpen={setOpen}
      modalTitle="Select Family"
      footer={
        <GKButton
          variant="contained"
          fullWidth
          startIcon={<CheckIcon />}
          disabled={!selectedFamily}
          onClick={() => {
            onFamilySelect(Number(selectedFamily)); // send back id
            setOpen(false); // close modal
          }}
        >
          Submit
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <GKTextField
            size="small"
            type="text"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            slotProps={{
              input: {
                startAdornment: (
                  <SearchIcon width={20} color={"var(--grey-500)"} />
                ),
                placeholder: "Search Family...",
              },
            }}
          />
        </Grid2>

        <Grid2 size={12} mt={2}>
          <div style={{ height: "265px", overflow: "auto" }}>
            {filteredFamily && filteredFamily.length > 0 ? (
              <RadioGroup
                value={selectedFamily}
                onChange={(e) => setSelectedFamily(e.target.value)}
              >
                {filteredFamily?.map((family) => (
                  <FormControlLabel
                    key={family.id}
                    value={family.id}
                    control={<GKRadio sx={{ padding: "0 8px 0 0" }} />}
                    label={family.name}
                    sx={{
                      "& .MuiFormControlLabel-label": { fontSize: 14 },
                      padding: "10px 0",
                    }}
                  />
                ))}
              </RadioGroup>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--grey-500)",
                  fontSize: 14,
                }}
              >
                No Data Found
              </div>
            )}
          </div>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default SelectFamilyModal;
